/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccessSummaryDashboard {
    getFixupPrototypeFunction() { return AccessSummaryDashboard.fixupPrototype; }

    static newInstance(model: Partial<AccessSummaryDashboard>): AccessSummaryDashboard {
        let obj = Object.assign(new AccessSummaryDashboard(), model);
        AccessSummaryDashboard.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccessSummaryDashboard>): AccessSummaryDashboard {
        if (!model) return null;
        return AccessSummaryDashboard.newInstance(<AccessSummaryDashboard> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccessSummaryDashboard) {
        if (!obj) return;

        models.AccessSummaryDashboard.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccessSummaryDashboard): boolean {
        Object.setPrototypeOf(obj, AccessSummaryDashboard.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the Service
     */
    service_name: string;

    /**
     * Contains the summary of violations
     */
    violation: any;

}
